import {queries} from '@cypro/engine/queries'
import {useQuery, useSuspenseQuery} from '@rocicorp/zero/react'

export function useGetSettings() {
  const query = queries.settings.getSettings()
  const [settings, meta] = useQuery(query)

  return {
    query,
    meta,
    settings,
    isFetching: meta.type === 'unknown',
  }
}

export function useSuspenseGetSettings() {
  const query = queries.settings.getSettings()
  const [settings, meta] = useSuspenseQuery(query)

  return {
    query,
    meta,
    settings,
    isFetching: meta.type === 'unknown',
  }
}
